// extracted by mini-css-extract-plugin
export default {"innerWrapper":"WA-z","tooltipWrapper":"XA-z","icon":"YA-z","tooltip":"ZA-z","content":"_A-z"};